import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import IletCaretAlert from "./components/IletCaretAlert";
import Hero from "./components/Hero";
import Excursions from "./components/Excursions";
import Tarifs from "./components/Tarifs";
import Photos from "./components/Photos";
import APropos from "./components/APropos";
import CtaStrip from "./components/CtaStrip";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppFloating from "./components/WhatsAppFloating";
import { Toaster } from "./components/ui/toaster";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <Header />
      <div className="pt-[92px]">
        <IletCaretAlert />
        <main>
          <Hero />
          <Excursions />
          <Tarifs />
          <Photos />
          <APropos />
          <CtaStrip />
          <Contact />
        </main>
      </div>
      <Footer />
      <WhatsAppFloating />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
